import React, { Component } from 'react'
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import * as actions from '../../stores/actionsList';
import HttpServices from '../../utils/Http.services';
import MessengerAdminView from './MessengerAdminView';
import MessengerUserView from './MessengerUserView';
import SocketServices from '../../utils/socket.services';
import Cookies from 'universal-cookie';
import StagesManager from '../../components/StagesManager';
import SettingsSwitcher from './database/SettingsSwitcher';
import { chooseFontColor } from '../../utils/useful';
import { framesConfig } from '../../variables/framesStatics';
import CollectionBaseUserView from './CollectionBaseUserView';
import BaseAdminView from './BaseAdminView';

class MessengerApplet extends Component {

    state = {
        stage: 1,
        isLoader: false,
        colors: {
            primaryColor: '#0085ff',
            secondaryColor: '#5BABF5',
            textColor: '#fff'
        }
    }

    componentDidMount() {
        console.log('thisprosp', JSON.parse(JSON.stringify(this.props)))
 
        let data = {}
        data.applet = this.props.applet


        let frames = this.props.frames
    
        this.setState({ isLoading: true })
        this.waitForId(10)
        this.updateWidth()
        if (Array.isArray(frames)) {
            console.log('this.props.framessl',this.props.frames)

            frames.forEach(element => {

                let frameInfo = framesConfig[element.type]

                if (frameInfo) {
                    Object.entries(frameInfo)?.map(([key, value]) => {
                        element[key] = value
                        if (typeof value == 'string' && value.startsWith('{{')) {
                            let baseValue = value.replace(/{/g, '').replace(/}/g, '')
                            element[key] = element[baseValue]
                        }
                    })
                }


            })
        }

        // console.log("frames, ", frames)
        // console.log('frammeesss',frames)

        let currentFrameName = frames ? frames[0]?.name : null
        this.setState({ frames, currentFrameName })

    }

    waitForId = (leftAttempt) => {
        // if (this.props.user?.info?._id) {
        this.checkDefaultTab()
        // } else {
        //     setTimeout(() => {
        //         if (leftAttempt != 0) {
        //             this.waitForId(leftAttempt - 1)
        //         } else {
        //             this.setState({ pageStatus: 401 })
        //         }
        //     }, 500);
        // }
    }


    selectPotentialUser = () => {
        let potentialUser = JSON.parse(JSON.stringify(this.props.applet))
        this.setState({ potentialUser })
    }

    sendNotif = (type, value, messenger, time = 1, tryTime = 0, cb) => {
        setTimeout(() => {
            if (SocketServices.socket?.connected) {
                SocketServices.emit('handleNotif', { type, value, messenger }, null, (info, err) => {
                    if (cb)
                        cb()
                })
            }
            else {
                if (tryTime < 10) {
                    this.sendNotif(type, value, messenger, time + 5, tryTime + 1, cb)
                }
            }
        }, time * 1000);
    }

    removePotentialUser = () => {
        let potentialUser = ''
        this.setState({ potentialUser })
    }

    selectApplet = (value, cb) => {
        if (this.props.applet?.settings?.type != 'support') {

            this.setState({ currentApplet: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
    }

    // getOnlineStatus = (messenger, cb, time = 1, tryTime = 0) => {
    //     setTimeout(() => {
    //         if (SocketServices.socket?.connected) {
    //             if (messenger) {
    //                 SocketServices.emit('getHubStatus', { messengerId: messenger?._id }, null, (info, err) => {
    //                     cb()
    //                 })
    //             }
    //             else {
    //                 cb()
    //             }
    //         }
    //         else {
    //             if (tryTime < 10) {
    //                 this.getOnlineStatus(messenger, cb, time + 5, tryTime + 1)
    //             }
    //         }
    //     }, time * 1000);
    // }

    // removeUser = (item) => {
    //     HttpServices.request('removeUser', item, (fetchResult, fetchError) => {
    //         if (fetchError) {
    //             return
    //         }
    //         let userInfo = this.state.userInfo
    //         let currentMessenger = this.state.currentMessenger
    //         userInfo = {}
    //         currentMessenger = {}
    //         this.setState({ userInfo, currentMessenger })
    //     })
    // }
    removeUser = (item, cb) => {
        this.setState({ isLoader: true })
        HttpServices.request('removeUser', item, (fetchResult, fetchError) => {
            if (fetchError) {
                return
            }
            let userInfo = this.state.userInfo
            let currentMessenger = this.state.currentMessenger
            userInfo = {}
            currentMessenger = {}
            if (fetchResult.info) {
                let messenger = fetchResult.info
                if (!Array.isArray(messenger)) {
                    messenger = [messenger]
                }
                this.props.actions.updateMessengers(messenger)
                setTimeout(() => {
                    this.setMessenger(fetchResult.info, () => {
                        this.setState({ isLoader: false })
                        if (cb) {
                            cb()
                        }
                    })
                }, 50);
            }
            this.setState({ userInfo, currentMessenger })
        })
    }

    componentDidUpdate(prevProps) {
        // console.log('thisprosp3', JSON.parse(JSON.stringify(this.props)))

        if ((JSON.stringify(this.props.windowData.path) != JSON.stringify(prevProps.windowData.path))) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.checkDefaultTab()
            })
        }
        if (JSON.stringify(this.props.data) !== JSON.stringify(prevProps.data)) {
            // setTimeout(() => {
            this.init()
            // }, 500);
        }
        if (prevProps.height != this.props.height) {
            this.updateWidth()
        }
    }

    checkDefaultTab() {
        let def = ''
        let pageType = null
        let pathname = this.props.windowData.path//window.location.pathname.split('/')
        let rootRef = this.props.route.split('/')
        rootRef = rootRef[rootRef.length - 1]
        let pageIsValid = false
        if (rootRef.includes('admin') || pathname.includes('admin')) {
            def = 'admin'
            pageType = 'admin'
            pageIsValid = true
        }
        if (!def) {
            def = ''
        }
        if (def === '') {
            pageType = ''
            pageIsValid = true
        }
        if (pageIsValid) {
            this.setState({ oldData: this.props.windowData }, () => {
                this.setState({ path: def, pageType }, () => {
                    setTimeout(() => {
                        this.setState({ page: null }, () => {
                            this.setState({ pageType, pageStatus: 200 }, () => {
                                if (this.stageManager) {
                                    if (pageType != 'admin') {
                                        this.setState({ messenger: null })
                                    }
                                    // console.log('pageTypepageTypepageTypess',pageType)
                                    this.stageManager.changeStage((pageType), () => {
                                    })
                                } else {

                                }
                            })
                        })
                    }, 10);
                })
            })
        } else {
            this.setState({ pageStatus: 404 })
        }
    }

    init = () => {
        // if (!this.props.adminView) {}
        // setTimeout(() => {
        let myId = this.props.user?.info?._id
        this.setState({ myId }, () => {
        })
        let data = this.props?.data
        if (data?.path?.length > 1) {
            let id = data.path[1]
            if (id.startsWith("h=")) {
            } else { }
            // this.stageManager.changeStage('room', null, null, true)
        } else {
            // this.stageManager.changeStage('home', null, null, true)
        }
        // }, 1000);
    }

    updateWidth = () => {
        // this.setState({ width: window.innerWidth })
        if (this.MessengerView) {
            let bound = this.MessengerView.getBoundingClientRect()
            this.setState({ mwidth: bound.width, mheight: bound.height })
        }
    }

    openOne = (item, potentialUser) => {
        this.setState({ stage: 2, potentialUser })
        this.setMessenger(item, () => {
            this.updateWidth()
        })
        let id = item?._id ?? 'h=' + potentialUser?.hub?.username
        let newLink
        newLink = this.props.baseUrl
        newLink = this.props.baseUrl.splice(2)
        newLink.push('admin')
        newLink.push(id)
        this.props.changeWindowLink(newLink)
        // this.fetchOne(item)
    }

    closeOne = () => {
        let newLink
        newLink = this.props.baseUrl
        newLink = this.props.baseUrl.splice(2)
        newLink.push('admin')
        this.setState({ stage: 1, messenger: null, potentialUser: null }, () => {
            this.props.changeWindowLink(newLink)
        })
    }

    changePage = (index) => {
        console.log('*changePAGE')
        this.setState({ currentPage: index }, () => {
            // this.fetchData()
            this.closeOne()
        })
    }

    setTopics = (value) => {
        this.setState({ topics: value }, () => {
            if (this.state.topics.length > 0) {
                this.topicView.open()
            }
        })
    }

    fetchRemove = () => {
        this.setState({ isLoadingRemove: true })
        let id = this.state.messenger._id
        HttpServices.request(this.props.page.removeUrl, { "id": id }, (fetchResult, fetchError) => {
            this.setState({ isLoadingRemove: false })
            if (fetchError) {
                this.props.actions.addNotif({ type: 'error', title: '{{lang}}errors.removeFailed', description: fetchError.message })
                return
            }
            let data = this.state.data
            data.splice(this.state.currentIndex, 1)
            this.setState({ data })
            this.removeModal.modal.hideModal()
            this.props.actions.addNotif({ type: 'success', title: '{{lang}}info.removedSuccesfully', description: '{{lang}}info.dataRemovedSuccessfully' })
            // this.fetchData(true)
            this.closeOne()
        })
    }

    setMessenger = (messenger, cb) => {
        this.setState({ topics: [], messenger: messenger }, () => {
            if (cb) {
                cb()
            }
        })
        // let token = ''//getVToken()
        // subscribeAdmin(this.state.topicId, token, 'visitor', this.visitorInfoUpdate)
    }

    setData = (key, value, reference, cb) => {
        if (reference == 'MessengerApplet') {
            this.setState({ [key]: value }, () => {
                if (cb) {
                    cb()
                }
            })
        }
        else {
            if (this.props.setData) {
                this.props.setData(key, value, reference, () => {
                })
            }
        }
    }

    render() {
        let colors = this.state.colors ?? {}
        let applet = this.props.applet
        if (applet?.colorType == 'sameAsHub') {

        }

        if (applet?.colorType == "custom") {
            colors = applet?.colors
        }

        if (!colors?.textColor) {
            colors.textColor = '#fff'
        }

        let iconInvert = chooseFontColor(colors.textColor) == '#fff' ? true : false

        colors.iconInvert = iconInvert
        colors.background = `linear-gradient(90deg, ${colors.primaryColor}, ${colors.secondaryColor})`

        let variables = {
            applet: this.props.applet,
            appletHub: this.props.applet.hub
        }
        // let currentApplet = { _id: this.props.applet._id, appletHub: this.props.applet.hub }
        return (
            <div className=" w-100 h-100 window-content-radius " style={{ backgroundColor: '#F5F5F5' }}>
                {/* {console.log('appletAccess={this.props.appletAccess}',this.props.appletAccess)} */}
                
                <StagesManager ref={el => this.stageManager = el} height={'100%'} fast={true}  >
                    {/* <MessengerAdminView stageName={'admin'} myId={this.state.myId} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl, 'admin']} language={this.props.language} width={this.props.width} height={this.props.height} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} topics={this.state.topics} setTopics={this.setTopics} sendNotif={this.sendNotif} setData={this.setData} removePotentialUser={this.removePotentialUser} selectApplet={this.selectApplet} currentApplet={this.state.currentApplet} isApplet={true} selectPotentialUser={this.selectPotentialUser} stage={this.state.stage} potentialUser={this.state.potentialUser} data={this.props.data} init={this.init} messenger={this.state.messenger} setMessenger={this.setMessenger} fetchRemove={this.fetchRemove} changePage={this.changePage} closeOne={this.closeOne} openOne={this.openOne} updateWidth={this.updateWidth} appletAccess={this.props.appletAccess} removeUser={this.removeUser} isLoader={this.state.isLoader} colors={colors} />
                    <MessengerUserView stageName={''} myId={this.state.myId} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl]} language={this.props.language} width={this.props.width} height={this.props.height} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} topics={this.state.topics} setTopics={this.setTopics} sendNotif={this.sendNotif} selectApplet={this.selectApplet} setData={this.setData} currentApplet={this.state.currentApplet} setMessenger={this.setMessenger} fetchRemove={this.fetchRemove} changePage={this.changePage} closeOne={this.closeOne} openOne={this.openOne} updateWidth={this.updateWidth} selectPotentialUser={this.selectPotentialUser} stage={this.state.stage} potentialUser={this.state.potentialUser} data={this.props.data} init={this.init} messenger={this.state.messenger} colors={colors} /> */}
                    <BaseAdminView updateFrames={this.updateFrames} updateUserSettings={this.props.updateUserSettings} userSettings={this.props.userSettings} stageName={'admin'} isDesktop={this.props.isDesktop} isMobile={this.props.isMobile} permissions={this.props.permissions} baseUrl={[...this.props.baseUrl, 'admin']} frames={this.state.frames} framesSections={this.state.framesSections} colors={colors} language={this.props.language} width={this.props.width} height={this.props.height} lastSelected={this.props.lastSelected} variables={this.props.variables} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} changeWindow={this.props.changeWindow} goToHub={this.props.goToHub} updateConnectionPermissions={this.props.updateConnectionPermissions} appletAccess={this.props.appletAccess} closeWindow={this.props.closeWindow} setData={this.setData} frameUpdateActions={this.props.frameUpdateActions} automations={this.props.automations} />
                    {/* <PageViewer userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height} */}

                    {/* <PagesStackNavigator
                        stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height} */}

                    <CollectionBaseUserView userView={true} stageName={''} baseUrl={[...this.props.baseUrl]} variables={this.props.variables} colors={colors} frames={this.state.frames} framesSections={this.state.framesSections} changeWindowLink={this.props.changeWindowLink} width={this.props.width} height={this.props.height}
                        windowData={this.props.windowData} route={this.props.rootUrl} applet={this.props.applet}
                        connection={this.props.connection} user={this.props.user} setUser={this.props.setUser}
                        addNotif={this.props.addNotif} history={this.props.history} location={this.props.location}
                        goToHub={this.props.goToHub} language={this.props.language} changeWindow={this.props.changeWindow} />
                </StagesManager>

            </div>
            // <div className="w-100 d-flex Messenger window-content-radius h-100"  >
            //     {this.props.adminView && (
            //         <MessengerAdminView topics={this.state.topics} language={this.props.language} setTopics={this.setTopics} sendNotif={this.sendNotif} removePotentialUser={this.removePotentialUser} selectApplet={this.selectApplet} currentApplet={this.state.currentApplet} width={this.props.width} isApplet={true} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} goToHub={this.props.goToHub} variables={variables} setMessenger={this.setMessenger} fetchRemove={this.fetchRemove} changePage={this.changePage} closeOne={this.closeOne} openOne={this.openOne} updateWidth={this.updateWidth} selectPotentialUser={this.selectPotentialUser} stage={this.state.stage} potentialUser={this.state.potentialUser} data={this.props.data} init={this.init} messenger={this.state.messenger} />
            //     )}
            //     {!this.props.adminView && (
            //         <div className="h-100 w-100 scroll-no-scrollbar">
            //             <MessengerUserView topics={this.state.topics} language={this.props.language} setTopics={this.setTopics} sendNotif={this.sendNotif} selectApplet={this.selectApplet} currentApplet={this.state.currentApplet} width={this.props.width} windowData={this.props.windowData} route={this.props.route} applet={this.props.applet} changeWindowLink={this.props.changeWindowLink} goToHub={this.props.goToHub} variables={variables} setMessenger={this.setMessenger} fetchRemove={this.fetchRemove} changePage={this.changePage} closeOne={this.closeOne} openOne={this.openOne} updateWidth={this.updateWidth} selectPotentialUser={this.selectPotentialUser} stage={this.state.stage} potentialUser={this.state.potentialUser} data={this.props.data} init={this.init} messenger={this.state.messenger} />
            //         </div>
            //     )}
            // </div>
        )
    }
}


const mapStateToProps = state => ({ settings: state.settings, user: state.user })
const mapDispatchToProps = dispatch => ({ actions: bindActionCreators(actions, dispatch) })

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(MessengerApplet);